/**
 * review-status-icon.js
 */

import React from 'react';
import { Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import Icon from 'components/icon';
import StatusBadge from '../status-badge';


export const ReviewResult = {
  NOT_REVIEWED: 'not-reviewed',
  REVIEWED: 'reviewed',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected'
};


export function ReviewStatusIcon(props) {
  const {
    resultId,
    count,
    to,
    showBadge,
    showTooltip
  } = props;

  let iconType = '';
  let title = '';

  switch (resultId) {
    case ReviewResult.NOT_REVIEWED:
      iconType = 'not-reviewed';
      title = `${count} record${count === 1 ? '' : 's'} awaiting review`;
      break;

    case ReviewResult.REVIEWED:
      iconType = 'reviewed';
      title = 'All completions reviewed';
      break;

    case ReviewResult.ACCEPTED:
      iconType = 'accepted';
      title = 'All completions reviewed';
      break;

    case ReviewResult.REJECTED:
      iconType = 'rejected';
      title = `${count} rejected record${count === 1 ? '' : 's'}`;
      break;

    default:
      break;
  }

    const baseContent = <Icon type={iconType} className={`icon-${iconType}`} />;

    const linkContent = to
      ? <Link to={to} style={{ position: 'relative', display: 'flex' }} children={baseContent} />
      : baseContent;

    const badgeContent = showBadge && count > 0
      ? <StatusBadge badgeContent={count} children={linkContent} />
      : linkContent;

    const tooltipContent = showTooltip
      ? <Tooltip
        arrow
        placement='top'
        title={title}
        style={{ position: 'relative', display: 'flex' }}
        children={badgeContent}
      />
      : badgeContent;

    return tooltipContent;
}